import React, {Component} from "react"
import {InjectedIntl} from "react-intl"

import Button from "@irati/ui/src/Button"
import {injectIntl} from "@irati/utils/lang"
import makeCSV from "@irati/utils/csv/makeCSV"
import {Tenant} from "@irati/types"
import medicalTracking from "@irati-tracking/medical"
import {getCsv} from "@irati/medical/services/medical"

interface Props {
  trackingEventName: string,
  tenant: Tenant,
  isInternal: boolean,
  Comp: Component,
  full?: boolean,
  large?: boolean
}

interface State {
  download: Promise<void> | null
}

class DownloadReport extends Component<InjectedIntl, State, Props> {
  static defaultProps = {
    Comp: Button
  }

  state: State = {
    download: null
  }

  downloadCsv = () => {
    const {tenant, trackingEventName} = this.props
    medicalTracking.downloadReport(trackingEventName)
    const download = getCsv(tenant.uuid).then((data) => {
      const fileName = `${tenant.subdomain}-activation-report.csv`
      makeCSV(data, fileName)
    })
    this.setState({download})
  }

  render() {
    const {download} = this.state
    const {children, Comp, full, large} = this.props

    return (
      <Comp onClick={this.downloadCsv} full={full} large={large} load={download}>
        {children}
      </Comp>
    )
  }
}

export default injectIntl(DownloadReport)
